/** @jsxImportSource @emotion/react */
import IngresoProductos from "./IngresoProductos";
import ArchivosDisponibles from "../ArchivosDisponibles";
import MuestrasProceso from "../MuestrasProceso";
import FormularioEnsayo from "./FormularioEnsayo";
import PasosAnteriores from "../PasosAnteriores";
import { Titulo } from "../../../shared";
import { Card } from "primereact/card";

export default function PasoIngreso({
  actividad,
  archivosPaso,
  archivoAgregado,
  pasoId,
  paso,
  modoLectura,
}) {
  return (
    <div className="grid">
      <div
        className="col-12 xl:col-6 lg:col-6 md:col-12 sm:col-12"
        css={{ display: "flex", flexDirection: "column", gap: "1em" }}
      >
        {paso.decisionesAnteriores?.length > 0 && (
          <Card>
            <Titulo><i className="pi pi-history" css={{ marginRight: "0.5em" }}></i>Pasos anteriores</Titulo>
            <PasosAnteriores pasosAnteriores={paso.decisionesAnteriores} />
          </Card>
        )}
        <Card>
          <FormularioEnsayo
            pasoId={pasoId}
            normaId={actividad.proceso.norma?.id}
            reportesEnActividad={actividad.reporteensayo}
            modoLectura={modoLectura}
          />
        </Card>

        <Card>
          <IngresoProductos
            key={`ingreso-productos-${pasoId}`}
            actividad={actividad}
            pasoId={pasoId}
            camposParaTabla={paso.camposParaTabla}
            productosParaTabla={paso.productosParaTabla}
            modoLectura={modoLectura}
          />
        </Card>
      </div>

      <div
        className="col-12 xl:col-6 lg:col-6 md:col-12 sm:col-12"
        css={{ display: "flex", flexDirection: "column", gap: "1em" }}
      >
        <ArchivosDisponibles
          archivosOriginales={archivosPaso}
          archivoAgregado={archivoAgregado}
          pasoId={pasoId}
          modoLectura={modoLectura}
          procesoNombre={actividad.proceso.nombre}
        />
        <MuestrasProceso pasoId={pasoId} />
      </div>
    </div>
  );
}
